import { SliceZoneC } from "@commercekit/prismic";
import type { HTMLComponent } from "@commercekit/react";
import type { BusinuessCusotmerAdvantagesSlice } from "~/lib/prismic";
import { BusinuessCusotmerAdvantages } from "~/lib/prismic/slices";

const WvRegisterHelp: HTMLComponent<{  businuessCusotmerAdvantagesSlice: BusinuessCusotmerAdvantagesSlice[];
}> = ({businuessCusotmerAdvantagesSlice}) => {
  return (
    <SliceZoneC
    slices={businuessCusotmerAdvantagesSlice}
    components={{ businuess_cusotmer_advantages: BusinuessCusotmerAdvantages }}
    defaultComponent={({ slice }) => (
      <div>{slice.slice_type}</div>
    )}
  />
  );
};
export default WvRegisterHelp;
